import { League, LeagueTable, LeagueTeam, LeagueTeamMember, Round, RoundMatch, Scorer, SportEvent, Team, TeamMember } from "@/models";
import { MutationTree } from "vuex";
import { getInitialState, SportEventState } from ".";
import { DEFAULT_CURRENCY } from "../../constants";

export const SportEventMutationTypes = {
  ClearState: "CLEAR_STATE",
  SetSportEvent: "SET_SPORT_EVENT",
  SetLeagues: "SET_LEAGUES",
  SetLeagueTeams: "SET_LEAGUE_TEAMS",
  SetSelectedLeagueId: "SET_SELECTED_LEAGUE_ID",
  SetLeagueTable: "SET_LEAGUE_TABLE",
  SetTopScorers: "SET_TOP_SCORERS",
  SetRounds: "SET_ROUNDS",
  SetSelectedRoundId: "SET_SELECTED_ROUND_ID",
  SetRoundMatches: "SET_ROUND_MATCHES",
  SetUserTeams: "SET_USER_TEAMS",
  SetUserTeamMembers: "SET_USER_TEAM_MEMBERS",
  SetRegisteredTeamMembers: "SET_REGISTERED_TEAM_MEMBERS",
  UpdateTeam: "UPDATE_TEAM"
};

export const mutations: MutationTree<SportEventState> = {
  [SportEventMutationTypes.ClearState](state: SportEventState) {
    state = Object.assign(state, getInitialState());
  },
  [SportEventMutationTypes.SetSportEvent](state: SportEventState, payload: SportEvent) {
    payload.entry_currency = DEFAULT_CURRENCY;
    state.sportEvent = payload;
  },
  [SportEventMutationTypes.SetLeagues](state: SportEventState, payload: League[]) {
    state.leagues = payload;
  },
  [SportEventMutationTypes.SetSelectedLeagueId](state: SportEventState, payload: number) {
    state.selectedLeagueId = payload;
  },
  [SportEventMutationTypes.SetLeagueTeams](state: SportEventState, payload: LeagueTeam[]) {
    state.teams = payload;
  },
  [SportEventMutationTypes.SetRegisteredTeamMembers](state: SportEventState, payload: LeagueTeamMember[]) {
    state.registeredTeamMembers = payload;
  },
  [SportEventMutationTypes.SetLeagueTable](state: SportEventState, payload: LeagueTable) {
    state.leagueTable = payload;
  },
  [SportEventMutationTypes.SetTopScorers](state: SportEventState, payload: Scorer[]) {
    state.topScorers = payload;
  },
  [SportEventMutationTypes.SetRounds](state: SportEventState, payload: Round[]) {
    state.rounds = payload;
  },
  [SportEventMutationTypes.SetSelectedRoundId](state: SportEventState, payload: number) {
    state.selectedRoundId = payload;
  },
  [SportEventMutationTypes.SetRoundMatches](state: SportEventState, payload: RoundMatch[]) {
    state.roundMatches = payload;
  },
  [SportEventMutationTypes.SetUserTeams](state: SportEventState, payload: Team[]) {
    state.userTeams = payload;
  },
  [SportEventMutationTypes.SetUserTeamMembers](state: SportEventState, payload: TeamMember[]) {
    state.userTeamMembers = payload;
  },
  [SportEventMutationTypes.UpdateTeam](state: SportEventState, payload: { teamId: number; value: LeagueTeam & { isLoading: boolean } }) {
    state.teams = state.teams.map(member => (member.id === payload.teamId ? payload.value : member));
  }
};
